//import '../../Styles/css/month.css';
import '../../Styles/css/Modal.css';
import './Month.scss';

//import AddTask from '@mui/icons-material/AddTask';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { Tooltip } from '@mui/material';
//import EventNote from '@mui/icons-material/EventNote';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
//import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import { STATUS_CRA } from '../../data/Interfaces';
// import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import usePostRequest from '../../hooks/usePostRequest';
import useRole from '../../hooks/useRole';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { StatutCra } from '../../Pages/Expert/CraX';
import { formatDateJJMMYYYY } from '../../Utils/dateFormatter';
import { calculateNbDaysOfAMonth, isHolidayOrWeekendOrNotStartedBdc } from '../../Utils/getCalendarMonthMatrix';
import { isHttpStatusSuccess, UpperCasePrenomNom } from '../../Utils/utils';
import { getDisabledValidateRejectCraForACanceledMission } from '../../Utils/utilsCraX';
import DialogRejetCraAndCraX from '../Dialogs/DialogRejetCraAndCraX';
import { buttonStyles, buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
import Day from './Day';
//import Detailsbar from './Detailsbar';
import PresTationSuppDialog from './PresTationSuppDialog';

export default function Month({
    currenMonth, cra, evts, holidaysDuMoisDuCra, idCra, dateDebutBDC, refreshCra, dateFinBDC
}) {
    Month.propTypes = {
        currenMonth: PropTypes.any,
        cra: PropTypes.any,
        evts: PropTypes.any,
        holidaysDuMoisDuCra: PropTypes.any,
        idCra: PropTypes.any,
        // role: PropTypes.any,
        onClickOut: PropTypes.func,
        refreshCra: PropTypes.func,
        dateDebutBDC: PropTypes.any,
        dateFinBDC: PropTypes.any,
        // nbrDay: PropTypes.any,
    };

    // console.log('craaaaa',cra);
    //===========================================================================================
    // if(auth?.roles == ROLES.Admin){setRoleURL('/admin');}
    // else if(auth?.roles == ROLES.Client){setRoleURL('/client');}
    // else if(auth?.roles == ROLES.Expert){setRoleURL('/expert');}
    let navigate = useNavigate();
    const role = useRole();
    // const axiosPrivate = useAxiosPrivate();
    const { setBackdropOpen } = useUtilities();
    const { device } = useWindowSize();
    const [openDialogRejetCras, setOpenDialogRejetCras] = useState(false);
    //const [showDetailsBar, setShowDetailsBar] = useState(false);
    const { postDataSilently, postData } = usePostRequest();
    const [openPrestationComplDialog, setOpenPrestationComplDialog] = useState(false);
    //================= sum: nombre des jour s'affichant sur le cra avec couler vert============================
    //number of days of the month
    let nbJrsMoisCra = calculateNbDaysOfAMonth(currenMonth);
    const [totalJours, setTotalJours] = useState(); //was initialized to nbJrsMoisCra [Khaoula]
    const { i18n } = useTranslation();
    const calculateToutalJours = () => {
        // if (role == 'expert') { //* OLD
        // * new: si le client/admin entre avant l'expert
        if ((role == 'expert'|| (role=='esn' && location.pathname.includes('craVente') && !cra?.nbrDays)) || ((role == 'client' && !cra?.nbrDays)||  (role=='esn' && !location.pathname.includes('craVente') && !cra?.nbrDays)) || (role == 'admin' && !cra?.nbrDays)) {
            //number of holidays days
            // let countDayHoliday = 0;
            //number of weekends days
            let countDayWeekend = 0;
            //number of weekends and holidays where he works
            // let countWorkedWeekendsHolidays = 0;
            // * free days are : holidays, weekends, and not yet starting bdc
            let countFreeDays = 0;
            let countTotalEventsCost = 0;
            // let listWeekends = [];
            // console.log('total from expert calculation - which reflect the reality', { currenMonth,
            //     date: Date(currenMonth['0'][0].$y, currenMonth['0'][0].$M + 1, 0),
            //     y: currenMonth['0'][0].$y,
            //     totalJours,
            //     m: currenMonth['0'][0].$M + 1 });
            // ! Days names WAS SAMEDI DIMANCHE here, the translation was done in the matrix function
            currenMonth.map((row) => {
                row.map((day) => {
                    if (day.$M === currenMonth['0'][0].$M) {
                        isHolidayOrWeekendOrNotStartedBdc({ day: day, dateDebutBDC: dateDebutBDC, dateFinBDC: dateFinBDC, holidaysDuMoisDuCra: holidaysDuMoisDuCra }) && countFreeDays++;
                    }
                    // * old way, we calculate number of weekends then later the numbers of holidays, but sometimes a weekend could be a holiday, so we substract 2days instead of 1 !
                    //     // console.log('TEST', day.$M === currenMonth['0'][0].$M, day.$M, currenMonth['0'][0].$M);
                    //     if (
                    //         // ! si on est toujours sur le meme mois du CRA, since current month contains the next month element in it's matrix [always 5*7 day]
                    //         day.$M === currenMonth['0'][0].$M &&
                    //         // et si on est sur un weekend
                    //         (day.format('dddd').toUpperCase() === 'SATURDAY' ||
                    //             day.format('dddd').toUpperCase() === 'SUNDAY')
                    //     ) {
                    //         countDayWeekend += 1;
                    //         listWeekends.push(day.format('DD-MM-YYYY'));
                    //     }
                });
            });
            //???????? if weekend and holiday mem....
            // holidaysDuMoisDuCra.map((hol) => {
            //     console.log({hol});
            //     if (hol !== null) { countDayHoliday += 1; }
            //     // (hol === null ? sumh += 0 : sumh += 1);
            // });
            // les events==les jours ou il y a des action de changement de statur [0.5-0-1]
            evts.map((event) => {
                // ? il ya des events qui ont ete dans des holidays : old way, car dans notre cas, ces jours supp seront dans la partie prest complementaire
                // if (
                //     holidaysDuMoisDuCra.indexOf(event.day) !== -1 ||
                //     listWeekends.indexOf(event.day) !== -1
                // ) {
                //     countWorkedWeekendsHolidays += 1;
                // }
                // console.log('the cost of the current event", event?.counter);
                countTotalEventsCost += event?.counter;
                //just to not to do a double loop, what I had
                // setSum((prev) => {
                //     return prev + event.counter;
                // });
                // sum = sum + ev.counter
            });
            // console.log({countWorkedWeekendsHolidays, totalJours });
            // 31(->6 y compris des weekend deja supprimé) -1 -8 +...+ev.counter =17
            const total = // ? Nbr des jours dans le mois du cra
                nbJrsMoisCra
                // ? nbr des evenement (important)
                // * here we supposed that all events are from the same month, since normally we cant just change a cra of a month to another month with its events
                - evts.length
                //  Total cost of events
                + countTotalEventsCost
                - countFreeDays
                //  ?nbr des weekend
                //  Nbr des holidays
                // - countDayHoliday
                // + countWorkedWeekendsHolidays
                - countDayWeekend;
            setTotalJours(total);
            // setSum((prev) => {
            //     return prev - evts.length - sumh - sumw + sume + eventSumCost;
            // });
            console.log({ 'calculating totalJours': total, nbJrsMoisCra, evtslength: evts.length, countTotalEventsCost, countFreeDays, countDayWeekend });
            // sum = sum - evts.length - sumh - sumw + sume;
        }
        // *le calcul se fail just cote expert , client et admin affichent juste la valeur parvient du backend, sauf si l expert n a pas encore entrer => le client /admin vont faire le calcul front end eux mm
        else {
            setTotalJours(cra?.nbrDays);
        }
    };
    useEffect(() => {
        if (nbJrsMoisCra)
            calculateToutalJours();
    }, [evts, nbJrsMoisCra]);

    // ! Don't put post action on useEffect
    // ? we will keep it for now, event it will send two requests, the first doens't contains events counter value, and the last will be correct, this is due to the events array pb, first time evts = [], then it may be equal to
    useEffect(() => {
        // console.log(totalJours, cra?.nbrDays);
        //* the waiting feedback bofore the calculation is done
        if (!totalJours && totalJours !== 0) {
            setBackdropOpen(true);
        }
        else {
            setBackdropOpen(false);
        }
        //* Update NBrDay (== sum ) of Cra on DB after any change
        if (
            // c'est expert qui peut modifier
            role == 'expert' &&
            // initializing sum
            totalJours >= 0
            // &&
            // changing the byDefault value of sum
            // totalJours !== nbJrsMoisCra &&
            // totalJours !== cra?.nbrDays
            // et sum est different de l'encienne valeur
            // && sum !== nbrDay
            // and having some events, but I is not a good idea, holidays also are count and will impact sum
            // && evts.length > 0
        ) {
            setBackdropOpen(true);
            updateNbJoursTravail().then(() =>
                setBackdropOpen(false)
            );
        }
        // }, [evts, sum, number1, number2, number3]); //! no need for all these dependencies
    }, [totalJours]);

    //===========================update date de validation de l'xpert et aussi le statut=========================================
    async function validateCra() {
        try {
            const response = await postData({ url: `/cra/validateCra/${idCra}${(role=='esn' && location.pathname.includes('craVente'))? '?isAchat=false':''}`, payload: { nbrDays: totalJours } });
            // const response = await axiosPrivate
            //     .post(`/cra/validateCra/${idCra}`);
            if (isHttpStatusSuccess(response?.responseStatus)) {
                if (role == 'expert') {
                    // * DISABLED POUR LE MOMENT: PAS DE % ds les PC
                    setOpenPrestationComplDialog(true);
                    // * si on trouve plus le probleme de remplissage aleatoires des cases des jours ,, on a plus besoins de ces navigates .. car on a la fonction de refreshCra
                    refreshCra();
                    // window.location.reload();
                    // Swal.fire({
                    //     //La prestation complémentaire a été validée avec succès!
                    //     title: 'Le CRA a été validé avec succès!',
                    //     icon: 'success',
                    //     confirmButtonColor: '#5CC889',
                    //     confirmButtonText: 'Ok',
                    // }).then((result) => {
                    //     if(result.isConfirmed){
                    //         navigate(`/${role}/AllCras`);
                    //     }
                    // });
                }
                else if (role == 'client' || (role=='esn' && !location.pathname.includes('craVente'))) {
                    // navigate(-1);
                    // * si on trouve plus le probleme de remplissage aleatoires des cases des jours ,, on a plus besoins de ces navigates .. car on a la fonction de refreshCra
                    refreshCra();
                    // window.location.reload();
                    Swal.fire({
                        title: i18n.t('Le CRA a été validé avec succès!'),
                        icon: 'success',
                        confirmButtonColor: '#5CC889',
                        confirmButtonText: 'Ok',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            navigate(`/${role}/AllCras`);
                        }
                    });
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    //===========================================update Nbr days==========================================================
    async function updateNbJoursTravail() {
        console.log({ evtslength: evts.length, totalJours, nbJrsMoisCra, nbrDays: cra?.nbrDays });
        postDataSilently({ url: `/cra/updateNbJoursTravail/${idCra}`, payload: { nbrDays: totalJours } }).then(() => refreshCra()); //this refreshCra could be useless ,, but I prefer to have it anyway, all this because the totalJours took some time to get the final value ,, and in this case we can't compare it with the nbrDays ,, since we know alredy it's unstable
    }

    // TODO:AIDA: clear CRA BUTTON: Month.js
    /**
     * search the variable of number of days of the month of the current cra, for exepmle numbrDaysMonth=30,
     * and then do an equivalent number of request, using a for loop, so if the index is a holiday don't execute the request, otherwise execute it.
     * POST : event/addEvent/ : search this api to understand how it works ,, and do the same with the same data structure ofc
     */

    return (
        <div className='FMonths0'>
            <div className='FMonths2 FMonthStretch'>
                <h4 className='titlesociete'>
                    {i18n.t('Compte rendu  d\'activité')} {role != 'expert' ? 'de ' : ' '}
                    <span style={{ color: 'rgb(92, 200, 137)' }}>
                        {role != 'expert' ? UpperCasePrenomNom(cra?.missionId?.expertId?.persoData) : ''}
                    </span>
                </h4>
                <div
                    className='FMonths2'
                    style={{ flexDirection: 'row', alignItems: 'center' }}
                >
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '4px' }}>
                        <CalendarTodayIcon />
                        <p className='datestyilng'>
                            {dayjs(new Date(dayjs().year(), cra?.month - 1)).format('MMMM')} {cra?.year}
                        </p>
                    </div>
                    <StatutCra
                        statutCra={cra?.statutCra}
                        motifRejet={cra?.motifR}
                    />
                </div>
            </div>
            <div className='FMonths1'>
                <div
                    className='FMonths2 FMonthStart'
                    style={{ flexDirection: 'row' }}
                >
                    {/*<Stack
                        direction="row"
                        spacing={2}
                    >*/}
                    <div >
                        {/*<Button
                            onClick={(e) => {
                                // two click on the day sum to close it, smart :)
                                switch (e.detail) {
                                case 1:
                                    setShowDetailsBar(true);
                                    break;
                                case 2:
                                    setShowDetailsBar(false);
                                    break;
                                }
                            }}
                        >*/}
                        <Box
                            // className={'bg-green-700 h-15 w-18 rounded flex items-center justify-center cursor-pointer'}
                            style={{
                                display: 'flex',
                                backgroundColor: '#BCE7CB',
                                justifyContent: 'center',
                                alignItems: 'center',
                                border: '1px solid #5CC889',
                                borderRadius: '10px',
                                width: '96px',
                                height: '96px',
                                fontSize: '10px'
                            }}
                        >
                            <p
                                style={{
                                    color: '#272D3C',
                                    fontFamily: 'Lato',
                                    fontStyle: 'normal',
                                    fontWeight: '700',
                                    fontSize: '34px',
                                    lineHeight: '44px',
                                }}
                            >{totalJours}{i18n.t('j')}</p>
                        </Box>
                    </div>
                    {/*{showDetailsBar &&
                    <Detailsbar
                        sum={totalJours}
                        ms={cra?.intituleMission}
                        statutCra={cra?.statutCra}
                        cl={cra?.nomClient}
                        ex={cra?.nomExpert}
                        op={showDetailsBar}
                        setShowDetailsBar={setShowDetailsBar}
                    />}*/}
                    {/*</Stack>*/}
                    <div className='FMonths3'>
                        <p className='titlesociete FMonthNoMarg'>{cra?.nomClient}</p>
                        <p
                            className='textIconsStyleB1'
                            style={{ textAlign: 'start' }}
                        >{cra?.intituleMission}</p>
                        <p className='FMOnthTextG'>{cra?.craId} | {i18n.t('Date début BDC')}: {formatDateJJMMYYYY(dateDebutBDC)} | {i18n.t('Date fin BDC')}: {formatDateJJMMYYYY(dateFinBDC)}</p>
                        {/*
                        {cra?.statutCra === STATUS_CRA?.NV && cra?.motifR !=='' &&
                        <p
                            style={{
                                color: '#B91C1C',
                                fontSize: '1.25rem',
                                lineHeight: '1.75rem',
                                fontWeight: '700',}}
                        >Motif Rejet de CRA : {cra?.motifR}
                        </p>}
                        */}
                    </div>
                </div>
                {/*
                // TODO: si deja facture est 'genere' = l'expert ne pourra plus revalider le cra
                //! pour ne pas avoir une faille dans le process
                // * NEW FEATURE:
                //TODO: tant que la facture n'est pas 'genere', l'expert a tjrs la possibilite de revalider son cra mm si le client l'a valider, et le client de meme peut rejeter un cra qui a ete valider par lui meme si la facture n'est pas 'genere'
                */}
                {(role == 'expert') && cra?.factureId?.statutFacture !== 'genere'
                    //cra?.statutCra !== STATUS_CRA?.VC
                    && <div className='FMonths2 FMonthEnd'>
                        <Tooltip
                            title={getDisabledValidateRejectCraForACanceledMission(
                                cra?.missionId?.statutMission,
                                cra?.missionId?.BDCs,
                                cra?.bdcId
                            ) ?
                                'Mission annulée' : ''}
                        >
                            <span style={{ width: device == 'desktop' ? 'auto' : '100%' }}>
                                <Button
                                    variant='contained'
                                    onClick={() => {
                                        validateCra();
                                    }}
                                    style={{
                                        ...buttonStylesGreen((getDisabledValidateRejectCraForACanceledMission(
                                            cra?.missionId?.statutMission,
                                            cra?.missionId?.BDCs,
                                            cra?.bdcId
                                        ))), ...{ height: '36px', width: device == 'desktop' ? 'auto' : '100%' }
                                    }}
                                    disabled={
                                        (getDisabledValidateRejectCraForACanceledMission(
                                            cra?.missionId?.statutMission,
                                            cra?.missionId?.BDCs,
                                            cra?.bdcId
                                        ))
                                    }
                                >
                                    {i18n.t('Valider')}
                                </Button>
                            </span>
                        </Tooltip>
                        {openPrestationComplDialog &&
                            <PresTationSuppDialog
                                handleClose={() => {
                                    setOpenPrestationComplDialog(false);
                                    navigate(-1);
                                }}
                                open={openPrestationComplDialog}
                                // I pass all this data obj to dialog, which will pass it to CRAX
                                cra={cra}
                            />}
                    </div>
                }
                {(role == 'client' || (role=='esn' && !location.pathname.includes('craVente'))) && cra?.statutCra !== STATUS_CRA?.pending && cra?.statutCra !== STATUS_CRA?.NULL &&
                    cra?.factureId?.statutFacture !== 'genere'
                    // cra?.statutCra !== STATUS_CRA?.VC
                    && <div className='FMonths2 FMonthEnd'>
                        <Tooltip
                            title={getDisabledValidateRejectCraForACanceledMission(
                                cra?.missionId?.statutMission,
                                cra?.missionId?.BDCs,
                                cra?.bdcId
                            ) ?
                                'Mission annulée' : ''}
                        >
                            <span style={{ width: device == 'desktop' ? 'auto' : '100%' }}>
                                <Button
                                    variant='contained'
                                    onClick={() => {
                                        validateCra();
                                    }}
                                    style={{
                                        ...buttonStylesGreen(getDisabledValidateRejectCraForACanceledMission(
                                            cra?.missionId?.statutMission,
                                            cra?.missionId?.BDCs,
                                            cra?.bdcId
                                        )), ...{ height: '36px', width: device == 'desktop' ? 'auto' : '100%' }
                                    }}
                                    disabled={
                                        getDisabledValidateRejectCraForACanceledMission(
                                            cra?.missionId?.statutMission,
                                            cra?.missionId?.BDCs,
                                            cra?.bdcId
                                        )
                                    }
                                >
                                    {i18n.t('Valider')}
                                </Button>
                            </span>
                        </Tooltip>
                        <Tooltip
                            title={getDisabledValidateRejectCraForACanceledMission(
                                cra?.missionId?.statutMission,
                                cra?.missionId?.BDCs,
                                cra?.bdcId
                            ) ?
                                i18n.t('Mission annulée') : ''}
                        >
                            <span style={{ width: device == 'desktop' ? 'auto' : '100%' }} >
                                <Button
                                    variant='contained'
                                    onClick={() => { setOpenDialogRejetCras(true); }}
                                    style={{ ...buttonStyles(), ...{ float: 'left', height: '36px', color: 'white', backgroundColor: '#F6AF39', width: device == 'desktop' ? 'auto' : '100%' } }}
                                    disabled={
                                        getDisabledValidateRejectCraForACanceledMission(
                                            cra?.missionId?.statutMission,
                                            cra?.missionId?.BDCs,
                                            cra?.bdcId
                                        )
                                    }
                                >
                                    {i18n.t('Rejeter')}
                                </Button>
                            </span>
                        </Tooltip>
                        {openDialogRejetCras &&
                            <DialogRejetCraAndCraX
                                idCra={idCra}
                                refreshCra={refreshCra}
                                setOpenDialogRejetCras={setOpenDialogRejetCras}
                                openDialogRejetCras={openDialogRejetCras}
                            />
                        }
                    </div>}
            </div>
            <div
                // className="container"
                style={{ width: '100%' }}
            >
                <div
                    // className="grid grid-cols-7 grid-rows- b-5 "
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
                        gridColumnGap: '2px',
                        gridRowGap: '2px',
                        height: '100%', width: '100%', float: 'right'
                    }}
                >

                    {currenMonth.map((row, i) => (
                        <React.Fragment key={i}>
                            {row.map((day, idx) => {
                                if (day.$M === currenMonth['0'][0].$M) {
                                    return (
                                        <Day
                                            day={day}
                                            rowIdx={i}
                                            evts={evts}
                                            expert={cra?.nomExpert}
                                            holidaysDuMoisDuCra={holidaysDuMoisDuCra}
                                            dateDebutBDC={dateDebutBDC}
                                            dateFinBDC={dateFinBDC}
                                            key={idx}
                                            statutCra={cra?.statutCra}
                                        />);
                                }
                            })}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </div>
    );
}

/*
                        {(role === 'admin' || role==='client') &&
                        (cra?.statutCra === STATUS_CRA?.VC ||
                        cra?.statutCra === STATUS_CRA?.VE) &&
                        <div>
                            <div>
                                <Button
                                    variant='contained'
                                    onClick={() => navigate('/' + role + '/CraX',
                                        {
                                            state: {
                                                month: currenMonth,
                                                evts,
                                                h: holidaysDuMoisDuCra,
                                                idCra,
                                                cl: cra?.nomClient,
                                                ex: cra?.nomExpert,
                                                ms: cra?.intituleMission,
                                                statutCra: cra?.statutCra,
                                                m: cra?.month,
                                                role,
                                                motifR : cra?.motifR
                                            }
                                        }
                                    )}
                                    sx={{ minWidth: '100px', padding: '10px', minHeight: '36px', float: 'right', color: 'lightGray',
                                        borderRadius: '8px', backgroundColor: '#6f42c1', '&:hover': { backgroundColor: 'blueviolet' }, }}
                                >
                                    <AddTask sx={{ fontSize: '20px', color: 'lightGray' }} />
                                Consulter le Cra Extra
                                </Button>
                            </div>
                        </div>
                        }
*/